import React, { useState, useEffect } from 'react';
import Joyride from 'react-joyride';
import { IconButton, Tooltip } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const TOUR_STORAGE_KEY = 'helperCalendarXlsTourSeen';

/**
 * HelperCalendarXls
 * Tour guida per CalXlsPage
 * @param {{ isAdmin: boolean, isManager: boolean, isMobile: boolean, hasEventList: boolean }} props
 */
export default function HelperCalendarXls({ isAdmin, isManager, isMobile, hasEventList }) {
  const isEditor = isManager || isAdmin;

  // passi comuni a tutti
  const commonSteps = [
    { 
      target: '#calx_title', 
      content: 'Gestisci i turni 112 del mese desiderato: ogni pulsante corrisponde ad una azione.', 
      disableBeacon: true 
    },
    { 
      target: '#calx_change', 
      content: 'Richiedi un cambio turno', 
      disableBeacon: true 
    },
    { 
      target: '#calx_vacant', // Presumibile ID/selettore del pulsante per i turni vacanti
      content: isEditor 
        ? 'Gestisci le richieste o assegna i turni vacanti' 
        : 'Richiedi un turno vacante', 
      disableBeacon: true 
    },
    { 
      target: '#calx_pending', 
      content: 'Verifica le richieste inoltrate e ricevute', 
      disableBeacon: true 
    },
    { 
      target: '#calx_refresh', 
      content: 'Ricarica il calendario con i dati più recenti.', 
      disableBeacon: true 
    },
    { 
      target: '#calx_datepicker', 
      content: 'Seleziona anno/mese desiderati.', 
      disableBeacon: true 
    },
  ];

  // passi per eventi personali (lista eventi da aggiungere al calendario)
  const eventListSteps = hasEventList ? [
    { target: '#calx-add-to-cal', content: 'Aggiungi i tuoi turni al tuo calendario personale.', disableBeacon: true },
  ] : [];

  // passi per manager / admin
  const managerSteps = isEditor ? [
    { target: '#calx-publish', content: 'Pubblica il calendario del mese selezionato.', disableBeacon: true },
    { target: '#calx-hide', content: 'Nascondi il calendario del mese selezionato.', disableBeacon: true },
    { target: '#calx-assign-shift', content: 'Verifica le assegnazioni fin qui fatte.', disableBeacon: true },
    { target: '#calx-print', content: 'Stampa o esporta il calendario in Excel.', disableBeacon: true },
  ] : [];

  // passi per abilitazione modifica admin
  const adminSteps = isEditor ? [
    { target: '#calx-toggle-edit', content: 'Abilita o disabilita la modalità modifica del calendario.', disableBeacon: true },
  ] : [];

  const steps = [
    ...commonSteps,
    ...eventListSteps,
    ...managerSteps,
    ...adminSteps
  ];

  const [run, setRun] = useState(false);

  useEffect(() => {
    localStorage.getItem(TOUR_STORAGE_KEY);
  }, []);

  const handleStart = () => {
    localStorage.setItem(TOUR_STORAGE_KEY, 'true');
    setRun(true);
  };

  const handleCallback = (data) => {
    if (['finished', 'skipped'].includes(data.status)) setRun(false);
  };

  return (
    <>
      <Tooltip title="Guida Turni">
        <IconButton
          onClick={handleStart}
          sx={{ 
            position: 'absolute', 
            zIndex: 1500,
            top: isMobile ? '58px' : '80px',
            left: isMobile ? '100px' : '120px',
          }}
        >
          <HelpOutlineIcon />
        </IconButton>
      </Tooltip>
      <Joyride
        steps={steps}
        run={run}
        continuous
        showSkipButton
        disableBeacon
        locale={{ next: 'Avanti', back: 'Indietro', skip: 'Salta', last: 'Fine', close: 'Chiudi' }}
        callback={handleCallback}
        styles={{
          options: { primaryColor: '#1976d2', backgroundColor: '#2C5282', textColor: '#fff', arrowColor: '#fff', zIndex: 1500 }
        }}
      />
    </>
  );
}